import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCreditBoxModal } from '../modules/active_modal';

import CreditsBox from './CreditsBox.jsx';

class IconCreditState extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    let counter = '', {dispatch} = this.props;
    let iconCredits = (
      <svg version="1.1" id="Layer_1" x="0px" y="0px" width="33px" height="33px" viewBox="0 0 864 864" enable-background="new 0 0 864 864">
        <circle fill="#A2B4B8" cx="424.5" cy="433.5" r="374"/>
        <g>
          <path fill="#00283F" d="M408.832,593.282c-41.729-5.668-79.64-20.852-111.884-47.397l30.364-43.609
            c26.546,22.76,53.064,36.032,83.399,41.7v-92.885c-70.127-18.956-102.371-43.608-102.371-96.687l0,0
            c0-51.186,39.821-85.31,100.491-91.006v-28.441h41.7v28.441c34.124,3.789,62.551,17.062,89.097,36.017l-26.546,45.504
            c-20.851-15.168-41.7-26.533-64.431-30.336v91.005c72.008,18.957,102.371,47.413,102.371,98.57v1.937
            c0,51.156-41.729,87.188-100.491,90.977v47.396h-41.7V593.282z M410.712,310.795c-30.335,1.894-45.518,18.956-45.518,39.82l0,0
            c0,18.956,9.515,32.229,45.518,43.595V310.795z M496.05,506.092L496.05,506.092c0-22.786-9.515-34.152-47.397-45.519v85.31
            C478.958,543.976,496.05,528.823,496.05,506.092z"/>
        </g>
      </svg>
      )
    if ( this.props.customer && this.props.customer.credit_total
      && this.props.customer.credit_total > 0) {
      counter = <span className="round-counter">{this.props.customer.credit_total}</span>;
    }

    return (
      <div>
        <span className="icon-holder credits unselectable" onClick={() => dispatch( openCreditBoxModal() )}>
          {counter}
          {iconCredits}
          <div className="menu-nav-text">Credits</div>
        </span>
        <div className={ ( this.props.activeModal === 'creditBox' ? " showing" : " hidden" ) } >
          <CreditsBox
          {...this.props}
          />
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'activeModal': state.activeModal,
      'customer': state.customer
    };
}

export default connect(mapStateToProps)(IconCreditState);


// WEBPACK FOOTER //
// ./src/components/IconCreditState.jsx